import { NoInformation as NoInformationIcon } from '@/components/chariot-ui';
import { NoData } from '@/components/legacy-ui/NoData';
import { MarkdownPreview } from '@/components/markdown/MarkdownPreview';
import { Seed } from '@/types';

interface DomainHistoryTabProps {
  seed: Seed;
  history?: string[];
  whoisHistoryStatus?: 'covered' | 'empty' | 'error';
}

export function DomainHistoryTab({
  seed: _seed,
  history,
  whoisHistoryStatus,
}: DomainHistoryTabProps) {
  if (whoisHistoryStatus === 'empty') {
    return (
      <div className="flex h-full flex-col">
        <NoData
          icon={
            <NoInformationIcon className="text-chariot-stroke mb-4 text-[100px]" />
          }
          title="No WHOIS history available for this TLD"
        />
      </div>
    );
  }

  if (whoisHistoryStatus === 'error') {
    return (
      <div className="flex h-full flex-col">
        <NoData
          icon={
            <NoInformationIcon className="text-chariot-stroke mb-4 text-[100px]" />
          }
          title="WHOIS history lookup failed"
        />
      </div>
    );
  }

  if (!history || history.length === 0) {
    return (
      <div className="flex h-full flex-col">
        <NoData
          icon={
            <NoInformationIcon className="text-chariot-stroke mb-4 text-[100px]" />
          }
          title="No History Found"
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 [&_code]:p-0!">
      {history.map((data: string, i: number) => (
        <MarkdownPreview
          key={i}
          source={`\`\`\`json\n${JSON.stringify(data, null, 2)}\n\`\`\``}
        />
      ))}
    </div>
  );
}
